var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 25,
    viewBox: "0 0 23 15"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "visible_svg__a",
    width: "111.4%",
    height: "107.4%",
    x: "-5.7%",
    y: "-3.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "visible_svg__b",
    d: "M11.662 5.455c-5.318 0-9.792 2.869-11.117 6.769 1.325 3.9 5.8 6.769 11.117 6.769 5.317 0 9.791-2.87 11.116-6.77-1.325-3.9-5.799-6.768-11.116-6.768zm0 12.007c-2.634 0-4.771-2.346-4.771-5.238 0-2.894 2.137-5.238 4.77-5.238 2.636 0 4.772 2.346 4.772 5.238 0 2.893-2.136 5.238-4.771 5.238zm0-8.576c-1.679 0-3.04 1.494-3.04 3.338 0 1.843 1.361 3.338 3.04 3.338s3.04-1.495 3.04-3.338c0-1.844-1.361-3.338-3.04-3.338z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#visible_svg__a)",
    transform: "translate(-613 -866.062)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#777",
    xlinkHref: "#visible_svg__b",
    transform: "translate(613 861.062)"
  }))));
}
export default SvgVisible;